import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import {
  setTermsOfUseAcceptance,
  useCurrentTermsOfUseAcceptance,
} from "../features/auth/authSlice";

import { createStyleSheet } from "../utils/styles";
import { theme } from "../../theme";
import { useAppDispatch } from "../features/store";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TermsOfUse = () => {
  const { t } = useTranslation("TermsOfUse");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const accepted = useCurrentTermsOfUseAcceptance();

  const handleAcceptedClicked = useCallback(() => {
    dispatch(setTermsOfUseAcceptance(!accepted));
  }, [accepted, dispatch]);
  const handleProceedClicked = useCallback(() => {
    if (accepted) {
      navigate("/patients");
    }
  }, [accepted, navigate]);

  return (
    <Box sx={styles.container}>
      <Typography variant="h2" sx={styles.title}>
        {t("termsOfUseTitle")}
      </Typography>
      <Typography
        variant="body1"
        sx={styles.body}
        dangerouslySetInnerHTML={{ __html: t("termsOfUseBody") }}
      />
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox checked={accepted} onClick={handleAcceptedClicked} />
          }
          label={t("acceptCheckbox")}
        />
      </FormGroup>
      <Box>
        <Button
          variant="contained"
          disabled={!accepted}
          onClick={handleProceedClicked}
          sx={styles.proceedButton}
        >
          {t("proceed")}
        </Button>
      </Box>
    </Box>
  );
};

const styles = createStyleSheet({
  container: {
    width: "100%",
    height: "100%",
    px: 16,
    [theme.breakpoints.down("desktop")]: {
      px: 13,
    },
    display: "flex",
    flexDirection: "column",
  },
  body: {
    textAlign: "left",
  },
  title: {
    textAlign: "center",
    my: 2,
    [theme.breakpoints.down("desktop")]: {
      my: 1.5,
    },
  },
  proceedButton: {
    marginTop: 4,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 3,
    },
  },
});

export default TermsOfUse;
